export default __webpack_public_path__ + "static/media/cart.a4fa124d.png";